// Blend modes for layer composition
export type BlendMode = 
  | 'source-over' | 'source-in' | 'source-out' | 'source-atop'
  | 'destination-over' | 'destination-in' | 'destination-out' | 'destination-atop'
  | 'lighter' | 'copy' | 'xor' | 'multiply' | 'screen' | 'overlay'
  | 'darken' | 'lighten' | 'color-dodge' | 'color-burn' | 'hard-light'
  | 'soft-light' | 'difference' | 'exclusion' | 'hue' | 'saturation'
  | 'color' | 'luminosity';

// Element in a layer (a trait option)
export interface LayerElement {
  id: number;
  name: string;
  weight: number;
  image: File | null;
  restrictions?: {
    incompatibleWith?: {
      layerId: number;
      elementIds: number[];
    }[];
  };
}

// Layer representing a trait category
export interface Layer {
  id: number;
  name: string;
  blend: BlendMode;
  opacity: number;
  elements: LayerElement[];
}

// Pricing tier structure
export interface PricingTier {
  minNFTs: number;
  maxNFTs: number | null; // null means unlimited
  price: string; // ETH amount as string (e.g. "0.001")
  label: string; // Display label (e.g. "Free", "Basic", etc.)
}

// Payment status
export enum PaymentStatus {
  NOT_REQUIRED = 'NOT_REQUIRED', // For free tier
  PENDING = 'PENDING',           // Payment needed
  PROCESSING = 'PROCESSING',     // Payment in progress
  COMPLETED = 'COMPLETED',       // Payment successful
  FAILED = 'FAILED'              // Payment failed
}

// Configuration for the NFT collection
export interface AppConfig {
  namePrefix: string;
  description: string;
  baseURI?: string; // Optional IPFS or other URI prefix for metadata
  format: {
    width: number;
    height: number;
    smoothing: boolean;
  };
  background: {
    generate: boolean;
    brightness: string;
    static: boolean;
    default: string;
  };
  extraMetadata: Record<string, any>;
  rarityDelimiter: string;
  uniqueDnaTorrance: number;
  layerConfigurations: {
    growEditionSizeTo: number;
    layersOrder: any[];
  }[];
}

// Metadata attribute for NFT traits
export interface MetadataAttribute {
  trait_type: string;
  value: string;
}

// Metadata for a generated NFT
export interface NFTMetadata {
  name: string;
  description: string;
  image: string;
  dna: string;
  edition: number;
  date: number;
  attributes: MetadataAttribute[];
  compiler: string;
  [key: string]: any;
}

// Generated image with its metadata
export interface GeneratedImage {
  imageDataUrl: string;
  metadata: NFTMetadata;
} 